import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-no-results',
  standalone: false,
  templateUrl: './no-results.component.html',
  styleUrl: './no-results.component.scss',
})
export class NoResultsComponent {
  @Input() message: string;
}
